import { connect } from 'react-redux';

// Components
import ButtonHeader from './ButtonHeader';

// Actions
import { goTo } from 'store/reducers/navigation/actions';

export default connect(
  null,
  { goTo }
)(ButtonHeader);



// WEBPACK FOOTER //
// ./src/components/atoms/ButtonHeader/ButtonHeaderContainer.js